import { useCallback } from 'react';
import { invoiceHiresService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { InvoiceHire } from '../types';

export function useInvoiceHires(
  options?: ResourceQueryOptions
): ResourceState<InvoiceHire> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      invoiceHiresService.getAll(opts) as unknown as Promise<{ data: InvoiceHire[]; meta?: any }>,
    []
  );
  return useResourceCollection<InvoiceHire>(fetchFn, options);
}

export function useInvoiceHire(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<InvoiceHire> {
  const resourceId = id;
  const fetchFn = useCallback(
    (invoiceHireId: string | number, opts?: ResourceQueryOptions) =>
      invoiceHiresService.getById(invoiceHireId, opts) as unknown as Promise<InvoiceHire>,
    []
  );
  return useResourceById<InvoiceHire>(fetchFn, resourceId, options);
}

export function useCreateInvoiceHire(
  onSuccess?: (data: InvoiceHire) => void
): MutationState<InvoiceHire> {
  const createFn = useCallback(
    (data: any) => invoiceHiresService.create(data) as unknown as Promise<InvoiceHire>,
    []
  );
  return useCreateResource<InvoiceHire>(createFn, onSuccess);
}

export function useUpdateInvoiceHire(
  onSuccess?: (data: InvoiceHire) => void
): MutationState<InvoiceHire> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return invoiceHiresService.update(id, data) as unknown as Promise<InvoiceHire>;
    },
    []
  );
  return useUpdateResource<InvoiceHire>(updateFn, onSuccess);
}

/**
 * Delete invoice hire using documentId
 * @param data - Full invoice hire object containing documentId
 */
export function useDeleteInvoiceHire(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return invoiceHiresService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}

